<template>
  <div class="mantle" data-test-id="mantle">
    <router-view />
    <mantle-shared-modals />
    <fib-message-boxes />
  </div>
</template>

<script setup lang="ts">
  import { FibMessageBoxes } from '@feeditback/fib-components';

  import MantleSharedModals from './components/sharedModals/MantleSharedModals.vue';
</script>

<!-- eslint-disable-next-line vue/enforce-style-attribute -->
<style lang="scss">
  body {
    margin: 0;
  }
</style>
